import { jsx as p } from "react/jsx-runtime";
import { ThemeName as e, fpds as l, fcds as n, useTheme as C } from "@fcamna/shared-component-foundations";
import { FordCreditIcons as E, FordProIcons as I } from "@fcamna/shared-icons";
import { c as g } from "./index-65016bfa.mjs";
import "react";
import { u as S } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
var r = /* @__PURE__ */ ((o) => (o.DEFAULT = "default", o.DANGER = "danger", o.SUCCESS = "success", o.ONCOLOR = "oncolor", o))(r || {});
const s = {
  [e.FORD_CREDIT]: E,
  [e.FORD_PRO]: I
}, D = {
  [e.FORD_PRO]: e.FORD_CREDIT,
  [e.FORD_CREDIT]: e.FORD_PRO
}, T = {
  [e.FORD_PRO]: {
    [r.DEFAULT]: l.semantic.color.fill.primaryStrong,
    [r.DANGER]: l.semantic.color.fill.dangerStrong,
    [r.SUCCESS]: l.semantic.color.fill.successStrong,
    [r.ONCOLOR]: l.semantic.color.fill.default
  },
  [e.FORD_CREDIT]: {
    [r.DEFAULT]: n.semanticMode1.color.fill.onLight.interactive.value,
    [r.DANGER]: n.semanticMode1.color.icon.onDark.danger.value,
    [r.SUCCESS]: n.semanticMode1.color.fill.onLight.successStrong.value,
    [r.ONCOLOR]: n.primitive.color.twilight[800].value
  }
}, G = ({ name: o, hidden: a, extended: O = !1, color: c, className: f, ...u }) => {
  var m;
  const { themeName: i, icons: R } = C(), F = S({ label: "Icon" });
  if (a || !o)
    return null;
  let t;
  return R && R[o] ? t = R[o] : s && (s[i || e.FORD_CREDIT][o] ? t = s[i || e.FORD_CREDIT][o] : s[D[e.FORD_CREDIT]][o] ? t = s[D[e.FORD_CREDIT]][o] : t = s[D[e.FORD_PRO]][o]), a || !t ? null : /* @__PURE__ */ p(
    t,
    {
      ...u,
      color: ((m = T[i]) == null ? void 0 : m[c]) || c,
      className: g(["Icon", `Icon--${c}`, `Icon--${o}`, f]),
      extended: O,
      ...F
    }
  );
};
export {
  G as Icon,
  r as IconColor,
  s as Icons
};
